/**
 * Auth User Reducers
 */
import { NotificationManager } from "react-notifications";
import {
  LOGIN_USER,
  LOGIN_USER_SUCCESS,
  LOGIN_USER_FAILURE,
  LOGOUT_USER,
  SIGNUP_USER,
  SIGNUP_USER_SUCCESS,
  SIGNUP_USER_FAILURE,
  LOGOUT_USER_SUCCESS,
  LOGOUT_USER_FAILURE,
  RESET_PASSWORD_STEP_ONE,
  RESET_PASSWORD_STEP_ONE_FAILURE,
  RESET_PASSWORD_STEP_ONE_SUCCESS,
  RESET_PASSWORD_STEP_TWO,
  RESET_PASSWORD_STEP_TWO_FAILURE,
  RESET_PASSWORD_STEP_TWO_SUCCESS,
  CREATE_ACCOUNT_FAILURE,
  CREATE_ACCOUNT,
  CREATE_ACCOUNT_SUCCESS,
  CREATE_NEW_PASSWORD,
  GET_NEW_PASSWORD
} from "Actions/types";

/**
 * initial auth user
 */
const INIT_STATE = {
  user: localStorage.getItem("user_id"),
  loading: false
};

export default (state = INIT_STATE, action) => {
  switch (action.type) {
    case CREATE_NEW_PASSWORD:
      return { ...state, loading: true };

    case GET_NEW_PASSWORD:
      return { ...state, loading: false, user: action.payload };

    case LOGIN_USER:
      return { ...state, loading: true };

    case LOGIN_USER_SUCCESS:
      console.log("LOGIN_USER_SUCCESS_ACTION", action);
      return { ...state, loading: false, user: action.payload };

    case LOGIN_USER_FAILURE:
      NotificationManager.error(action.payload);
      return { ...state, loading: false };

    case RESET_PASSWORD_STEP_ONE:
      return { ...state, loading: true };

    case RESET_PASSWORD_STEP_ONE_SUCCESS:
      NotificationManager.success(
        `Code sent to ${action.payload.deliveryMedium}`
      );
      return { ...state, loading: false };

    case RESET_PASSWORD_STEP_ONE_FAILURE:
      NotificationManager.error(action.payload);
      return { ...state, loading: false };

    case CREATE_ACCOUNT:
      return { ...state, loading: true };

    case CREATE_ACCOUNT_SUCCESS:
      NotificationManager.success("Account Created");
      return { ...state, loading: false };

    case CREATE_ACCOUNT_FAILURE:
      NotificationManager.error(action.payload);
      return { ...state, loading: false };

    case RESET_PASSWORD_STEP_TWO:
      return { ...state, loading: true };

    case RESET_PASSWORD_STEP_TWO_SUCCESS:
      NotificationManager.success("Password Changed");
      return { ...state, loading: false };

    case RESET_PASSWORD_STEP_TWO_FAILURE:
      NotificationManager.error(action.payload);
      return { ...state, loading: false };

    case LOGOUT_USER:
      return { ...state };

    case LOGOUT_USER_SUCCESS:
      return { ...state, user: null };

    case LOGOUT_USER_FAILURE:
      return { ...state };

    case SIGNUP_USER:
      return { ...state, loading: true };

    case SIGNUP_USER_SUCCESS:
      NotificationManager.success("Account Created");
      return { ...state, loading: false, user: action.payload.uid };

    case SIGNUP_USER_FAILURE:
      NotificationManager.error(action.payload);
      return { ...state, loading: false };

    default:
      return { ...state };
  }
};
